import { z } from 'zod';

export const DisplayVariant = z.enum(['grid', 'social', 'featuredArticle']);

export type DisplayVariant = z.infer<typeof DisplayVariant>;
